import { IWizardDataModel } from '../models/IWizardDataModel';

class WizardSessionData {
  private models: IWizardDataModel[] = [];

  addModel(model: IWizardDataModel) {
    this.models.push(model);
  }

  getWizardData() {
    let data = this.models.map((model) => model.getWizardData());

    data = data.map((model) => {
      for (const key in model) {
        if (key === 'address') continue;
        
        if (model[key] === '' || model[key] === void 0) {
          model[key] = null;
        }
      }

      return model;
    });

    const finalData = data.reduce((acc, val) => {
      return { ...acc, ...val };
    }, {});

    return finalData;
  }
}

export default new WizardSessionData();
